module.exports = __webpack_public_path__ + "img/mobile-logo.58f978f2.png";